export const txnDateType = [
  {
    text: "Transaction Date",
    value: "1",
  },
  {
    text: "Approved Date",
    value: "2",
  },
];
export const returnuserTypes = [
  {
    txt: "Individual",
    val: "IND",
  },
  {
    txt: "Business",
    val: "BUS",
  },
];
export const txnStatusReports = [
  {
    text: "All",
    value: "All",
  },
  {
    text: "Paid",
    value: "PAID",
  },
  {
    text: "Un Paid",
    value: "UNPAID",
  },
];

export const txn_analysis_method_options = [
  {
    txt: "All",
    val: "A",
  },
  {
    txt: "Bank transfer",
    val: "B",
  },
  {
    txt: "Cash pickup",
    val: "C",
  },
  {
    txt: "wallet",
    val: "W",
  },
];

export const txn_analysis_kyc_type = [
  {
    txt: "All",
    val: "ALL",
  },
  {
    txt: "KYC",
    val: "KYC",
  },
  {
    txt: "EKYC",
    val: "EKYC",
  },
];
export const txn_analysis_report_type = [
  {
    value_code: 0,
    value: "All",
  },
  {
    value_code: 1,
    value: "By Amount",
  },
  {
    value_code: 2,
    value: "No Of Transaction",
  },
  {
    value_code: 3,
    value: "Non Home Country",
  },
  {
    value_code: 4,
    value: "1 Sender To Many Beneficiary",
  },
  {
    value_code: 5,
    value: "Many Sender To 1 Beneficiary",
  },
  {
    value_code: 6,
    value: "On Behalf Transacition",
  },
];
